const partnerRoutePrefix = '/partner';

export { partnerRoutePrefix };
